import React, { useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useCreateKeyMutation,
  useDeleteKeyMutation,
  useFetchKeysQuery,
} from "../../store/api/apiSlice";
import { Button as CustomBtn } from "../../ui";

const KeyManagement = () => {
  const { data, isLoading, error, refetch } = useFetchKeysQuery({});
  const keysData = data?.keys || [];
  const [addKey] = useCreateKeyMutation();
  const [deleteKey] = useDeleteKeyMutation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const keyNameRef = useRef(null);

  const totalPages = Math.ceil(keysData.length / itemsPerPage);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const keyData = {
      title: keyNameRef.current?.value || "",
    };

    try {
      await addKey(keyData).unwrap();
      toast.success("Key created successfully!");
      refetch();
      closeModal();
    } catch (error) {
      toast.error("Error creating key");
    }
  };

  const handleDelete = async (keyId) => {
    try {
      await deleteKey(keyId).unwrap();
      toast.success("Key deleted successfully");
      refetch();
    } catch (error) {
      toast.error("Error deleting key");
    }
  };

  const paginatedKeys = keysData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div
        className=" pb-4 gap-4 pt-4 keyManagement_cont"

      >
        <CustomBtn onClick={openModal}>Create New Key</CustomBtn>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Key Title</th>
            <th>Secret key</th>
            <th>Expiry Date</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedKeys.map((key) => (
            <tr key={key._id}>
              <td>{key.title}</td>
              <td>{key.secret_key}</td>
              <td>{new Date(key.expiry_date).toLocaleString()}</td>
              <td>{new Date(key.createdAt).toLocaleString()}</td>
              <td>
                <img
                  className="Update-delete-icon"
                  onClick={() => handleDelete(key._id)}
                  width="30"
                  height="30"
                  src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                  alt="filled-trash"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>

      {isModalOpen && (
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <div
           className="admin_CreateModal"
          >
            <h3>Create New Key</h3>
            <CustomForm onSubmit={handleSubmit} className="d-grid gap-3">
              <Form.Control placeholder="Key Title" ref={keyNameRef} required />
              <div className="d-flex justify-content-between mt-4">
                <Button variant="secondary" onClick={closeModal}>
                  Cancel
                </Button>
                <Button type="submit">Save</Button>
              </div>
            </CustomForm>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default KeyManagement;
